import React from "react";

function TransactionResponseCodes() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h1>Transaction Response Codes</h1>
              <hr />
            </section>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-color">
                  <th> RESPONSE_CODE</th>
                  <th>MESSAGE</th>
                </tr>
                <tr className="table-center-txt">
                  <td>0</td>
                  <td>Successful</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00001</td>
                  <td>Invalid Merchant ID</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00002</td>
                  <td>Encryption key notfound.</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00003</td>
                  <td>Invalid Amount</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00004</td>
                  <td>IncorrectOrder Number</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00005</td>
                  <td>Transaction amountislessthan minimum allowed limit.</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00006</td>
                  <td>Daily Transaction Amount Limit Exceeded</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00007</td>
                  <td>Weekly Transaction Amount Limit Exceeded</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00008</td>
                  <td>Monthly Transaction Amount Limit Exceeded</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00009</td>
                  <td>Quarterly Transaction Amount Limit Exceeded</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00010</td>
                  <td>Half Yearly TransactionAmount Limit Exceeded</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00011</td>
                  <td>
                    Transaction amountis greater thanmaximum allowed limit.
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00012</td>
                  <td>Yearly TransactionAmount Limit Exceeded</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00013</td>
                  <td>Daily Transaction Count Exceed</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00014</td>
                  <td>Weekly TransactionCount Exceed</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00015</td>
                  <td>Monthly Transaction Count Exceed</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00016</td>
                  <td>Quarterly Transaction Count Exceeded</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00017</td>
                  <td>Half Yearly Transaction Count Exceeded</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00018</td>
                  <td>Yearly Transaction Count Exceeded</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00019</td>
                  <td>DuplicateOrder Number</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00020</td>
                  <td>Merchant Velocity Rules Not Defined</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00021</td>
                  <td>Invalid Transaction Type</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00022</td>
                  <td>Invalid SuccessURL</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00023</td>
                  <td>Invalid Failure URL</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00024</td>

                  <td>Invalid Channel</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00025</td>

                  <td>Invalid Country or Currency Code</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00026</td>
                  <td>Invalid Payment Gateway</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00027</td>

                  <td>Invalid Paymode</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00028</td>
                  <td>Invalid Scheme</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00029</td>
                  <td>Invalid Card Number</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00030</td>
                  <td>Invalid Expiry Date</td>
                </tr>

                <tr className="table-center-txt">
                  <td>00031</td>
                  <td>Invalid CVV Number</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00032</td>
                  <td>Transaction cancelled by the customer.</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00033</td>
                  <td>Invalid Credit Card Details</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00034</td>
                  <td>Invalid Debit Card Details</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00035</td>
                  <td>Nomatching fee structure found.</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00036</td>
                  <td>
                    Merchant fee is equal to or greater than transaction amount
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00037</td>
                  <td>Payment Gateway Fee Structure is not defined.</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00038</td>
                  <td>
                    Payment Gateway fee is equal to or greater than transaction
                    amount
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00039</td>
                  <td>Aggregator Fee Structure is not defined</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00040</td>
                  <td>
                    Aggregator fee is equal to or greater than transaction
                    amount
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00041</td>
                  <td>Nomatching reseller fee structure found</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00042</td>
                  <td>
                    Reseller fee is equal to or greater than transaction amount.
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00043</td>
                  <td>
                    Total fee is equal to or greater than transaction amount.
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00044</td>
                  <td>Card Authorization Failed</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00045</td>
                  <td>Card Capture Failed</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00046</td>
                  <td>Received fail response from the bank.</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00047</td>
                  <td>Invalid Mobikwik Wallet Checksum</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00048</td>
                  <td>Transaction amountis notmatching the response amount</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00049</td>
                  <td>Invalid Customer Name</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00050</td>
                  <td>Invalid Customer Email ID</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00051</td>
                  <td>Invalid Customer Mobile Number</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00052</td>
                  <td>Invalid EMI Months</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00053</td>
                  <td>The given amount is not valid</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00054</td>
                  <td>
                    Refund is not processed further astotal refunded amount is
                    higher than transaction amount.
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00055</td>
                  <td>
                    Invalid Transaction ID. Please try again with valid
                    transaction details.
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00056</td>
                  <td>The given Transaction ID orMerchant id is not valid</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00057</td>
                  <td>The selected bank is not valid</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00058</td>
                  <td>Refund Failed.</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00059</td>
                  <td>
                    We have already received your refund request. It will be
                    processed soon
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00060</td>
                  <td>Problem in bank response.</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00061</td>
                  <td>Merchantfee is not defined properly.</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00062</td>
                  <td>
                    You are not authorized to process this refund request,
                    kindly contact Administrator or email to
                    riskops@safexpay.com.
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00063</td>
                  <td>International Cards Not Supported.</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00064</td>
                  <td>TransactionHost Time Out</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00065</td>
                  <td>Debit card is not allowed for EMItransactions.</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00066</td>
                  <td>Transaction amount exceeds the permissible limit!</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00067</td>
                  <td>Card type unsupported to the merchant.</td>
                </tr>
                {/* <tr className="table-center-txt">
                  <td>00068</td>
                  <td>INVALID VPA</td>
                </tr> */}
                <tr className="table-center-txt">
                  <td>00069</td>
                  <td>INVALID VPA</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00070</td>
                  <td>OTP Resend limit exceeded</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00071</td>
                  <td>Your Account has been blocked</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00072</td>
                  <td>
                    The transactionvalue seems to be higherthan your available
                    LazyPay credit limit
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00073</td>
                  <td>
                    The transaction value seems to be higher than your mapped
                    fee for Merchant
                  </td>
                </tr>
                <tr className="table-center-txt">
                  <td>00074</td>
                  <td>Recieved Pending Response from Bank</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00075</td>
                  <td>Could not be refunded due to insufficient funds</td>
                </tr>
                <tr className="table-center-txt">
                  <td>00076</td>
                  <td>The capture has already been fully refunded</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default TransactionResponseCodes;
